module.exports = __webpack_public_path__ + "static/media/Privacy-2.495a281b.png";